import React from 'react';
import DOMPurify from 'dompurify';

// Components
import { Text } from '@react-pdf/renderer';
import Paragraph from '../../Paragraph';

export default function CoCreation({
  coCreation
}) {
  return (
    <Paragraph title="Co-creation">
      <Text>{DOMPurify.sanitize(coCreation || '')}</Text>
    </Paragraph>
  );
}